<template>
  <div class="banner">
    <div class="bannerImg">
      <img :src="bannerImg" alt />
      <img :src="bannerImg1" alt />
      <img :src="bannerImg2" alt />
    </div>

    <div class="banner_text">
      <div class="wenzi">
        <img :src="wenziImg" />
      </div>

      <!-- <div class="wenzi1">2021年，中国共产党迎来了百岁华诞，百年奋斗征途，党带领着全国人民走过峥嵘岁月，谱写下了中华民族自强不息、顽强奋进的壮丽史诗。为庆祝这一历史性时刻，中文在线书香中国平台精心策划，特别推出以“品读红色经典 铭记建党初心”
      为主题的系列阅读互动活动，再现中国共产党百年奋斗的光辉历程和举世瞩目的伟大成就。</div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  data() {
    return {
      headerImg: require("../../assets/img/return.png"),
      bannerImg: require("../../assets/img/pc/bg1.png"),
      bannerImg1: require("../../assets/img/pc/bg2.png"),
      bannerImg2: require("../../assets/img/pc/bg3.png"),
      wenziImg: require("../../assets/img/pc/zhuti.png")
    };
  },
  created() {
    if (window.location.host == "sxdc.chineseall.cn") {
      this.wenziImg = require("../../assets/img/pc/zhutid.png");
    } else {
      this.wenziImg = require("../../assets/img/pc/zhuti.png");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 7.9rem;
  padding-top: 1.07rem;
  .bannerImg {
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
    }
  }
  .banner_text {
    position: relative;
    z-index: 1000;
    width: 12rem;
    margin: 0 auto;
    .wenzi {
      width: 10.36rem;
      margin-bottom: 0.4rem;

      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    .wenzi1 {
      padding: 0 0.22rem;
      font-size: 0.2rem;
      line-height: 0.41rem;
      color: #f8e3a4;
      font-family: Source Han Sans SC;
    }
  }
}
</style>
